module.exports = __webpack_public_path__ + "media/images/talent/case06-badge-0f9430c4a46b17dde0c55dbf28ff93e8.png";